import { scrollTo } from '@fnv-core/dom';
import { Logger } from '@fnv-core/logging';
import { IPlugin, PluginManager } from '@fnv-static/plugins';

const PLUGIN_SELECTOR = '.js-scroll-on-click';

interface IScrollOptions {
  scrollToElement: HTMLElement;
}

/**
 * Plugin for scrolling to another element when clicking on an element.
 */
class ScrollOnClick implements IPlugin {
  constructor(private _element: HTMLElement) {}

  private _getOptions(): IScrollOptions {
    const scrollToElementSelector = this._element.getAttribute('data-scroll-on-click-element');
    const scrollToElement = document.querySelector<HTMLElement>(scrollToElementSelector);

    return {
      scrollToElement,
    };
  }

  init() {
    const options = this._getOptions();

    Logger.info(`Initialising plugin ScrollOnClick for element ${this._element} with options ${options}`);

    this._element.addEventListener('click', (event) => {
      event.preventDefault();

      scrollTo(options.scrollToElement);
    });
  }
}

export function initScroll() {
  const elements = document.querySelectorAll<HTMLElement>(PLUGIN_SELECTOR);
  elements.forEach(element => {
    const scrollPlugin = new ScrollOnClick(element);
    scrollPlugin.init();
  });
}

PluginManager.registerPlugin('scroll-on-click', initScroll);
